import {extend, localize} from "vee-validate";
import {min, max, required, email, min_value, max_value} from "vee-validate/dist/rules";
import en from "vee-validate/dist/locale/en.json";

extend("min", min);
extend("max", max);
extend("required", required);
extend("email", email);
extend("min_value", min_value)
extend("max_value", max_value)

extend('collective_value_not_null', {
    params: ['target'],
    validate(value, {target}) {
        return value + target > 0;
    },
    message: 'Need a minimum of 1 for either option'
});

extend('mintags', {
    params: ['min'],
    validate(value, {min}) {
        return value.length > min;
    },
    message: `Need a minimum of ${min} product`
});

extend('checked', {
    validate(value) {
        return value === true;
    },
    message: 'This field must be checked'
});

localize({
    custom: {
        'patient.name.first': {
            required: "The Patient's first name is required"
        }
    },
    en: {
        ...en,
        custom: {
            'patient.name.first': {
                required: "The Patient's First Name is required"
            }
        },
        attributes: {
            'patient.name.first': "Patient's First Name"
        }
    }
});
